import { createStyles, Divider, Stack, Title } from '@tf/ui';
import React from 'react';

import type { SanctionListItem } from '../types';

import { Item } from './Item';

const useStyles = createStyles(({ colors }) => ({
	border: {
		borderColor: colors.gray[2],
	},
}));

interface Props {
	title: string;
	sanctionList?: SanctionListItem[];
}

export const SanctionList: React.FC<Props> = ({ title, sanctionList }) => {
	const { classes } = useStyles();

	if (!sanctionList) return null;

	if (sanctionList.length > 0) {
		return (
			<Stack gap={0}>
				<Title order={4}>{title}</Title>
				{sanctionList.map((item, index) => (
					<React.Fragment key={`${item.name}-${index}`}>
						<Item item={item} />
						{index !== sanctionList.length - 1 && <Divider className={classes.border} my="sm" />}
					</React.Fragment>
				))}
			</Stack>
		);
	}

	return null;
};
